export default __webpack_public_path__ + "static/media/msg-activity.0996b062.svg";